export const setLang=(state,lang)=>{
    state.lang=lang+'/'
}

export const setCur=(state,cur)=>{
    state.cur=cur
}

export const pushTab=(state,item)=>{
    state.Tabs.push(item)
}

export const setTabs=(state,tabs)=>{
    state.Tabs=tabs
}

export const setMenus=(state,menus)=>{
    state.menus=menus
}

export const setTypes=(state,types)=>{
    state.types=types
}

export const setAction=(state,action)=>{
    state.action=action
}

export const saveBreadcrumb=(state,breadcrumb)=>{
    state.breadcrumb=breadcrumb
}

export const setActiveTab=(state,activeTab)=>{
    state.activeTab=activeTab
}